import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-bg" aria-hidden="true"></div>
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <span className="hero-eyebrow fade-in">Sambista · Escultor · Poeta</span>
            <h1 className="hero-title fade-in">Varella Sambista</h1>
            <p className="hero-description fade-in">
              Artista plural de Mirai/MG, radicado em Barra Mansa/RJ. Do samba de raiz
              da boêmia carioca às esculturas em barro moldadas por mais de 30 anos de
              técnica autodidata — uma vida inteira transformada em arte.
            </p>
            <div className="hero-buttons fade-in">
              <button className="btn" onClick={() => scrollTo('gallery')}>
                Ver as obras
              </button>
              <button className="btn btn-secondary" onClick={() => scrollTo('contact')}>
                Contratar / Contato
              </button>
            </div>

            <ul className="hero-badges fade-in">
              <li>
                <strong>10</strong>
                <span>músicas no Palco MP3</span>
              </li>
              <li>
                <strong>5</strong>
                <span>roteiros de curta-metragem</span>
              </li>
              <li>
                <strong>Sindicato Nacional</strong>
                <span>dos Compositores</span>
              </li>
              <li>
                <strong>Editora Cristal Music</strong>
                <span>parceria oficial</span>
              </li>
            </ul>
          </div>

          <div className="hero-image fade-in">
            <div className="hero-photo-disc" aria-hidden="true"></div>
            <img
              src="/fotooculos.png"
              alt="Varella Sambista, artista plural de Barra Mansa"
              className="hero-portrait"
              width="420"
              height="560"
            />
          </div>
        </div>
      </div>

      <button
        className="hero-scroll"
        onClick={() => scrollTo('highlights')}
        aria-label="Rolar para os destaques"
      >
        <span></span>
      </button>
    </section>
  );
};

export default Hero;
